module.exports = __webpack_public_path__ + "static/media/resultats_or2020.58c5f640.jpg";